import React from 'react';
import { motion } from 'framer-motion';
import { Star, BadgeCheck } from 'lucide-react';
export function TestimonialsSection() {
  const reviews = [{
    text: 'Das Topping lässt sich gut unter das Futter mischen und hilft sehr gut bei Magenproblemen und morgendlichem Erbrechen.',
    author: 'Annelies B.',
    location: 'Pöllau, AT',
    verified: true,
    dogImg: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=100&q=80'
  }, {
    text: 'Pinscher, 7 Jahre alt, Allergien, Fell-Probleme, kratzen. 6 Wochen das Magen & Darm Topping gegeben und eine Wirkung, die man nicht beschreiben kann. Fell, Kot, alles hat sich regeneriert. 2. Mal bestellt; wir bleiben dabei. Vielen Dank dafür.',
    author: 'Claudia S.',
    location: 'Münster, DE',
    verified: true,
    dogImg: 'https://images.unsplash.com/photo-1598133894008-61f7fdb8cc3a?auto=format&fit=crop&w=100&q=80'
  }, {
    text: 'Es ist Mega!!! Seitdem mein Hund es in seinem Futter mische frisst er kein Gras mehr und leckt sich nicht mehr an den Pfoten! Vielen Dank für dieses tolle Produkt!',
    author: 'Jessica Anna H.',
    location: 'Oberhausen, DE',
    verified: true,
    dogImg: 'https://images.unsplash.com/photo-1534361960057-19889db9621e?auto=format&fit=crop&w=100&q=80'
  }, {
    text: 'Seitdem Mogli das Futtertopping bekommt, frisst er kein Gras mehr und auch die Analdrüsen sind nicht mehr entzündet. Auch das Pfoten lecken ist besser geworden. Ich werde definitiv dabei bleiben und kann es nur empfehlen.',
    author: 'Anonym',
    location: 'Stuttgart, DE',
    verified: true,
    dogImg: 'https://images.unsplash.com/photo-1561037404-61cd46aa615b?auto=format&fit=crop&w=100&q=80'
  }];
  return <section className="max-w-3xl mx-auto px-6 py-16" data-id="element-125">
      <div className="text-center mb-10" data-id="element-126">
        <h2 className="text-2xl font-bold text-brand-brown mb-3" data-id="element-127">
          Nicht nur Max geht es besser
        </h2>
        <p className="text-stone-600 font-serif" data-id="element-128">
          Echte Bewertungen von verifizierten Käufern:
        </p>
      </div>

      <div className="space-y-5" data-id="element-129">
        {reviews.map((review, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.12
      }} className="bg-white p-5 sm:p-6 rounded-lg border border-stone-100 shadow-sm" data-id="element-130">
            <div className="flex items-center justify-between mb-3" data-id="element-131">
              <div className="flex items-center gap-3" data-id="element-132">
                <img src={review.dogImg} alt={`Hund von ${review.author}`} className="w-10 h-10 rounded-full object-cover" data-id="element-133" />
                <div data-id="element-134">
                  <div className="flex items-center gap-1.5" data-id="element-135">
                    <span className="font-sans font-bold text-stone-800 text-sm" data-id="element-136">
                      {review.author}
                    </span>
                    {review.verified && <BadgeCheck className="w-4 h-4 text-emerald-500" data-id="element-137" />}
                  </div>
                  <div className="flex gap-0.5 mt-0.5" data-id="element-138">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-brand-amber text-brand-amber" data-id="element-139" />)}
                  </div>
                </div>
              </div>
              <span className="text-xs text-stone-400 font-sans" data-id="element-140">
                {review.location}
              </span>
            </div>
            <p className="font-serif text-base sm:text-lg text-stone-700 leading-relaxed" data-id="element-141">
              {review.text}
            </p>
          </motion.div>)}
      </div>
    </section>;
}